import { useState, useEffect } from 'react';

/**
 * Hook for managing inner tab state within a report section with localStorage persistence
 * Stores the active tab ID (e.g., "register", "sales-summary") per section (e.g., "sales", "labor")
 * Similar to React Admin's useSidebarState()
 */
export const useReportInnerTabState = (sectionKey: string, defaultTabId?: string) => {
  const storageKey = `active_report_inner_tab_${sectionKey}`;
  
  const [tabId, setTabId] = useState<string | null>(() => {
    try {
      const stored = localStorage.getItem(storageKey);
      return stored && stored.trim() ? stored : (defaultTabId || null);
    } catch {
      return defaultTabId || null;
    }
  });

  useEffect(() => {
    try {
      if (tabId && tabId.trim()) {
        localStorage.setItem(storageKey, tabId);
      }
    } catch (error) {
      console.error(`[ReportTab] Failed to store inner tab for ${sectionKey}:`, error);
    }
  }, [tabId, storageKey, sectionKey]);

  return [tabId, setTabId] as const;
};


